// extracted by mini-css-extract-plugin
export default {"container":"_c177321f"};